import Pattern from '@/assets/pattern.svg'
import { View } from '@/components/layouts/View'
import { storeActions } from '@/store/actions'
import { useStoreDispatch } from '@/store/hooks'
import { H1 } from '@repo/ui/h1'
import { useT } from '@repo/ui/hooks'
import { useEffect, useRef } from 'react'
import { Location, Outlet, useLocation, useParams } from 'react-router-dom'

export function Root() {
  const { beneficiaryId } = useParams()
  const location = useLocation()
  const prevLocationRef = useRef<Location>()
  const dispatch = useStoreDispatch()
  const { i18n } = useT()

  useEffect(() => {
    const isNewLocation =
      location.pathname !== prevLocationRef.current?.pathname
    const initActions = async () => {
      if (beneficiaryId)
        await dispatch(
          storeActions.initBeneficiary({
            beneficiaryId,
            onInitialised: ({ beneficiary, organization }) => {
              if (beneficiary.language)
                void i18n.changeLanguage(beneficiary.language)
              else void i18n.changeLanguage(organization.language)
            },
          }),
        )
    }

    if (isNewLocation) {
      prevLocationRef.current = location
      void initActions()
    }
  }, [location])

  return (
    <View>
      {beneficiaryId ? (
        <Outlet />
      ) : (
        <div className="relative flex flex-1 items-center justify-center">
          <div
            className="absolute inset-0 z-0 bg-cover bg-center opacity-15"
            style={{ backgroundImage: `url(${Pattern})` }}
          />
          <H1 className="text-primary">CaseAi</H1>
        </div>
      )}
    </View>
  )
}
